import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  <div id="revision">
  <div id="revision-details">
    {{d-icon "pencil-alt"}}
    <LinkTo
      @route="user"
      @model={{@model.username}}
      class="revision-details__user"
    >
      {{bound-avatar-template @model.avatar_template "small"}}
      {{@model.username}}
    </LinkTo>
    <PluginOutlet
      @name="revision-user-details-after"
      @outletArgs={{hash model=@model}}
    />
    <span class="date">{{bound-date @model.created_at}}</span>
    {{#if @model.edit_reason}}
      <span class="edit-reason">{{@model.edit_reason}}</span>
    {{/if}}

    {{#if this.site.desktopView}}
      <span>
        {{#if @model.user_changes}}
          {{bound-avatar-template
            @model.user_changes.previous.avatar_template
            "small"
          }}
          {{@model.user_changes.previous.username}}
          &rarr;
          {{bound-avatar-template
            @model.user_changes.current.avatar_template
            "small"
          }}
          {{@model.user_changes.current.username}}
        {{/if}}

        {{#if @model.wiki_changes}}
          {{d-icon
            "far-edit"
            class=(if @model.wiki_changes.current "diff-ins" "diff-del")
          }}
        {{/if}}

        {{#if @model.post_type_changes}}
          {{d-icon
            "shield-alt"
            class=(if
              (eq
                @model.post_type_changes.current
                @site.post_types.moderator_action
              )
              "diff-del"
              "diff-ins"
            )
          }}
        {{/if}}

        {{#if @model.archetype_changes}}
          {{d-icon
            (if
              (eq @model.archetype_changes.current "private_message")
              "envelope"
              "comment"
            )
          }}
        {{/if}}

        {{#if (and @model.category_id_changes (not @model.archetype_changes))}}
          {{#if @previousCategory}}
            {{html-safe @previousCategory}}
          {{else}}
            {{d-icon "far-eye-slash" class="diff-del"}}
          {{/if}}
          &rarr;
          {{#if @currentCategory}}
            {{html-safe @currentCategory}}
          {{else}}
            {{d-icon "far-eye-slash" class="diff-ins"}}
          {{/if}}
        {{/if}}
      </span>
    {{/if}}
  </div>

  {{#if this.site.desktopView}}
    <div id="display-modes">
      <ul class="nav nav-pills">
        <li>
          <a
            href
            class={{concat-class
              "inline-mode"
              (if (eq @viewMode "inline") "active")
            }}
            {{on "click" @displayInline}}
            title={{i18n "post.revisions.displays.inline.title"}}
            aria-label={{i18n "post.revisions.displays.inline.title"}}
          >
            {{d-icon "far-square"}}
            {{i18n "post.revisions.displays.inline.button"}}
          </a>
        </li>
        <li>
          <a
            href
            class={{concat-class
              "side-by-side-mode"
              (if (eq @viewMode "side_by_side") "active")
            }}
            {{on "click" @displaySideBySide}}
            title={{i18n "post.revisions.displays.side_by_side.title"}}
            aria-label={{i18n "post.revisions.displays.side_by_side.title"}}
          >
            {{d-icon "columns"}}
            {{i18n "post.revisions.displays.side_by_side.button"}}
          </a>
        </li>
        <li>
          <a
            href
            class={{concat-class
              "side-by-side-markdown-mode"
              (if (eq @viewMode "side_by_side_markdown") "active")
            }}
            {{on "click" @displaySideBySideMarkdown}}
            title={{i18n "post.revisions.displays.side_by_side_markdown.title"}}
            aria-label={{i18n
              "post.revisions.displays.side_by_side_markdown.title"
            }}
          >
            {{d-icon "columns"}}
            {{i18n "post.revisions.displays.side_by_side_markdown.button"}}
          </a>
        </li>
      </ul>
    </div>
  {{/if}}
</div>
*/
{
  "id": "Q6lSbB2W",
  "block": "[[[10,0],[14,1,\"revision\"],[12],[1,\"\\n  \"],[10,0],[14,1,\"revision-details\"],[12],[1,\"\\n    \"],[1,[28,[35,0],[\"pencil-alt\"],null]],[1,\"\\n    \"],[8,[39,1],[[24,0,\"revision-details__user\"]],[[\"@route\",\"@model\"],[\"user\",[30,1,[\"username\"]]]],[[\"default\"],[[[[1,\"\\n      \"],[1,[28,[35,2],[[30,1,[\"avatar_template\"]],\"small\"],null]],[1,\"\\n      \"],[1,[30,1,[\"username\"]]],[1,\"\\n    \"]],[]]]]],[1,\"\\n    \"],[8,[39,3],null,[[\"@name\",\"@outletArgs\"],[\"revision-user-details-after\",[28,[37,4],null,[[\"model\"],[[30,1]]]]]],null],[1,\"\\n    \"],[10,1],[14,0,\"date\"],[12],[1,[28,[35,5],[[30,1,[\"created_at\"]]],null]],[13],[1,\"\\n\"],[41,[30,1,[\"edit_reason\"]],[[[1,\"      \"],[10,1],[14,0,\"edit-reason\"],[12],[1,[30,1,[\"edit_reason\"]]],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,0,[\"site\",\"desktopView\"]],[[[1,\"      \"],[10,1],[12],[1,\"\\n\"],[41,[30,1,[\"user_changes\"]],[[[1,\"          \"],[1,[28,[35,2],[[30,1,[\"user_changes\",\"previous\",\"avatar_template\"]],\"small\"],null]],[1,\"\\n          \"],[1,[30,1,[\"user_changes\",\"previous\",\"username\"]]],[1,\"\\n          →\\n          \"],[1,[28,[35,2],[[30,1,[\"user_changes\",\"current\",\"avatar_template\"]],\"small\"],null]],[1,\"\\n          \"],[1,[30,1,[\"user_changes\",\"current\",\"username\"]]],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,1,[\"wiki_changes\"]],[[[1,\"          \"],[1,[28,[35,0],[\"far-edit\"],[[\"class\"],[[52,[30,1,[\"wiki_changes\",\"current\"]],\"diff-ins\",\"diff-del\"]]]]],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,1,[\"post_type_changes\"]],[[[1,\"          \"],[1,[28,[35,0],[\"shield-alt\"],[[\"class\"],[[52,[28,[37,7],[[30,1,[\"post_type_changes\",\"current\"]],[30,2,[\"post_types\",\"moderator_action\"]]],null],\"diff-del\",\"diff-ins\"]]]]],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,1,[\"archetype_changes\"]],[[[1,\"          \"],[1,[28,[35,0],[[52,[28,[37,7],[[30,1,[\"archetype_changes\",\"current\"]],\"private_message\"],null],\"envelope\",\"comment\"]],null]],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[28,[37,8],[[30,1,[\"category_id_changes\"]],[28,[37,9],[[30,1,[\"archetype_changes\"]]],null]],null],[[[41,[30,3],[[[1,\"            \"],[1,[28,[35,10],[[30,3]],null]],[1,\"\\n\"]],[]],[[[1,\"            \"],[1,[28,[35,0],[\"far-eye-slash\"],[[\"class\"],[\"diff-del\"]]]],[1,\"\\n\"]],[]]],[1,\"          →\\n\"],[41,[30,4],[[[1,\"            \"],[1,[28,[35,10],[[30,4]],null]],[1,\"\\n\"]],[]],[[[1,\"            \"],[1,[28,[35,0],[\"far-eye-slash\"],[[\"class\"],[\"diff-ins\"]]]],[1,\"\\n\"]],[]]]],[]],null],[1,\"      \"],[13],[1,\"\\n\"]],[]],null],[1,\"  \"],[13],[1,\"\\n\\n\"],[41,[30,0,[\"site\",\"desktopView\"]],[[[1,\"    \"],[10,0],[14,1,\"display-modes\"],[12],[1,\"\\n      \"],[10,\"ul\"],[14,0,\"nav nav-pills\"],[12],[1,\"\\n        \"],[10,\"li\"],[12],[1,\"\\n          \"],[11,3],[24,6,\"\"],[16,0,[28,[37,11],[\"inline-mode\",[52,[28,[37,7],[[30,5],\"inline\"],null],\"active\"]],null]],[16,\"title\",[28,[37,12],[\"post.revisions.displays.inline.title\"],null]],[16,\"aria-label\",[28,[37,12],[\"post.revisions.displays.inline.title\"],null]],[4,[38,13],[\"click\",[30,6]],null],[12],[1,\"\\n            \"],[1,[28,[35,0],[\"far-square\"],null]],[1,\"\\n            \"],[1,[28,[35,12],[\"post.revisions.displays.inline.button\"],null]],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,\"li\"],[12],[1,\"\\n          \"],[11,3],[24,6,\"\"],[16,0,[28,[37,11],[\"side-by-side-mode\",[52,[28,[37,7],[[30,5],\"side_by_side\"],null],\"active\"]],null]],[16,\"title\",[28,[37,12],[\"post.revisions.displays.side_by_side.title\"],null]],[16,\"aria-label\",[28,[37,12],[\"post.revisions.displays.side_by_side.title\"],null]],[4,[38,13],[\"click\",[30,7]],null],[12],[1,\"\\n            \"],[1,[28,[35,0],[\"columns\"],null]],[1,\"\\n            \"],[1,[28,[35,12],[\"post.revisions.displays.side_by_side.button\"],null]],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,\"li\"],[12],[1,\"\\n          \"],[11,3],[24,6,\"\"],[16,0,[28,[37,11],[\"side-by-side-markdown-mode\",[52,[28,[37,7],[[30,5],\"side_by_side_markdown\"],null],\"active\"]],null]],[16,\"title\",[28,[37,12],[\"post.revisions.displays.side_by_side_markdown.title\"],null]],[16,\"aria-label\",[28,[37,12],[\"post.revisions.displays.side_by_side_markdown.title\"],null]],[4,[38,13],[\"click\",[30,8]],null],[12],[1,\"\\n            \"],[1,[28,[35,0],[\"columns\"],null]],[1,\"\\n            \"],[1,[28,[35,12],[\"post.revisions.displays.side_by_side_markdown.button\"],null]],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]],null],[13]],[\"@model\",\"@site\",\"@previousCategory\",\"@currentCategory\",\"@viewMode\",\"@displayInline\",\"@displaySideBySide\",\"@displaySideBySideMarkdown\"],false,[\"d-icon\",\"link-to\",\"bound-avatar-template\",\"plugin-outlet\",\"hash\",\"bound-date\",\"if\",\"eq\",\"and\",\"not\",\"html-safe\",\"concat-class\",\"i18n\",\"on\"]]",
  "moduleName": "discourse/components/modal/history/revision.hbs",
  "isStrictMode": false
});